// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Sy8Owx_FSYOORsNCdfqBU","addTwoFactor":"_2NoiiMDZrPSK3oOVerTvdK","text":"_3MbJ_zwzxm7qljA_2kqQpU"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/TwoFactor/styles.css
// module id = 2938
// module chunks = 0